import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchAssociationQueueEntry(id) {
    return useQuery(['associationQueue', id], () => PESService.getAssociationQueueEntry(id), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchAssociationQueueEntry;
